module.exports = __webpack_public_path__ + "assets/img/header_logo_black.f83efb31.png";